import React from 'react';
import { TooltipRenderProps, Step } from 'react-joyride';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, InfoArea, CloseButton } from '../styles';

interface Props {
  tooltipProps: any;
  step: Step;
  closeProps: any;
}

const Tooltip: React.FunctionComponent<TooltipRenderProps> = ({ tooltipProps, step, closeProps }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container {...tooltipProps}>
      <InfoArea>
        <img src="/images/check.svg" alt="" />
        <p>{step.content}</p>
        <CloseButton onClick={closeProps.onClick}>{t('tooltip.close')}</CloseButton>
      </InfoArea>
    </Container>
  );
};

export default Tooltip;
